export enum CALENDAR_SETTINGS_TABS {
    WorkSchedule = "workSchedule",
    Custom = "custom",
    EventType = "eventType"
}
